import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import FavouriteService from "./favourite.services";

export const getFavouriteList = createAsyncThunk(
    "favourites/get-favourites",
    async ({ data, userId }, thunkAPI) => {
        try {
            return await FavouriteService.getfavourites(data, userId);
        } catch (error) {
            if (error.response.status === 401) {
                window.location.href = "/";
            }
            return await error?.response?.data;
        }
    }
);

export const setFavorite = createAsyncThunk(
    "favourites/set-favourite",
    async (data, thunkAPI) => {
        try {
            const response = await FavouriteService.setFavorite(data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data);
        }
    }
);

// Function to remove the favourite
export const removeFavourite = createAsyncThunk(
    "favourites/remove-favourite",
    async (data, thunkAPI) => {
        try {
            const response = await FavouriteService.removeFavourite(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data);
        }
    }
);

export const resetState = createAction("RevertAll");

const initialState = {
    favourites: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
    setFavorite: null,
    removeFavourite: null,
    favouriteUpdated: false, // NEW: shared flag for cross-component sync
};

export const favouriteSlice = createSlice({
    name: "favourite",
    initialState,
    reducers: {
        setFavouriteUpdated(state, action) {
            state.favouriteUpdated = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFavouriteList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFavouriteList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.favourites = action.payload;
            })
            .addCase(getFavouriteList.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(setFavorite.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(setFavorite.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.setFavorite = action.payload;

            })
            .addCase(setFavorite.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(removeFavourite.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(removeFavourite.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.removeFavourite = action.payload;
            })
            .addCase(removeFavourite.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            // Reset state when resetState action is dispatched
            .addCase(resetState, () => initialState);
    },
});

// Export actions and reducer
export const { setFavouriteUpdated } = favouriteSlice.actions;
export default favouriteSlice.reducer;